import { render, staticRenderFns } from "./AllCharges.vue?vue&type=template&id=4dbdba9c"
import script from "./AllCharges.vue?vue&type=script&lang=js"
export * from "./AllCharges.vue?vue&type=script&lang=js"
import style0 from "./AllCharges.vue?vue&type=style&index=0&id=4dbdba9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports